import { MonthlyFee } from "./enums/enums";

export interface ExpiratedValues {
  value: MonthlyFee;
  severity: "success" | "info" | "warning" | "danger" | null | undefined;
  message: string;
}

export const expiratedValues: ExpiratedValues[] = [
  {
    value: MonthlyFee.UNPAID,
    severity: "info",
    message: "Sin deuda",
  },
  {
    value: MonthlyFee.DEFEATED,
    severity: "danger",
    message: "Vencida",
  },
  {
    value: MonthlyFee.FOR_DEFEATED,
    severity: "warning",
    message: "Por vencer",
  },
  {
    value: MonthlyFee.PAID,
    severity: "success",
    message: "Pagada",
  },
  {
    value: MonthlyFee.OVERPAIMENT,
    severity: "info",
    message: "P/Excedido",
  },
  {
    value: MonthlyFee.INCOMPLETE,
    severity: "warning",
    message: "Incompleta",
  },
  {
    value: MonthlyFee.WITHOUT,
    severity: "info",
    message: "Sin cuota",
  },
];
